module.exports = require("module");


//////////////////
// WEBPACK FOOTER
// external "module"
// module id = 27
// module chunks = 0